import { useState, useEffect } from 'react';

export default function useContainerDimensions(ref) {
  const getDimensions = () => {
    return !ref?.current
      ? { width: null, height: null }
      : {
          width: ref.current.offsetWidth,
          height: ref.current.offsetHeight,
        };
  };

  const [dimensions, setDimensions] = useState(getDimensions());

  // update on ref change
  useEffect(() => {
    setDimensions(getDimensions());
  }, [ref]);

  // update on resize
  useEffect(() => {
    const handleResize = () => {
      setDimensions(getDimensions());
    };

    window.addEventListener('resize', handleResize);

    return () => {
      window.removeEventListener('resize', handleResize);
    };
  }, []);

  return dimensions;
}
